__turbopack_context__.v({
  "controls": "Carousel-module-scss-module__xbbfAq__controls",
  "next": "Carousel-module-scss-module__xbbfAq__next",
  "prev": "Carousel-module-scss-module__xbbfAq__prev",
  "root": "Carousel-module-scss-module__xbbfAq__root",
  "rootCarMatch": "Carousel-module-scss-module__xbbfAq__rootCarMatch",
  "tile": "Carousel-module-scss-module__xbbfAq__tile",
  "track": "Carousel-module-scss-module__xbbfAq__track",
});
